import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "qtl-vendor" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["title", "aria-label"]
const _hoisted_4 = ["disabled", "title", "aria-label"]
const _hoisted_5 = { class: "qtl-vendor-confirm" }
const _hoisted_6 = { class: "qtl-vendor-confirm__text" }
const _hoisted_7 = { class: "qtl-vendor-confirm__actions" }

import { computed, ref } from "vue";
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import { i18n } from "@/i18n";
import type { TableDataCell } from "@/models/interfaces/entity-settings/querytable/querytable";
import { ColumnCategory } from "@/models/etc/types";
import { storageStore } from "@/store/storage/storage-instances";
import { storagePositionsStore } from "@/store/storage/storage-positions";
import { formatSimpleHtml } from "./cellFormat";
import MostaContextMenu from "@/components/common/basic/MostaContextMenu.vue";
import ItemInfoDialog from "@/components/multiedit/temporary/storageshared/ItemInfoDialog.vue";
import MoveInfoDialog from "@/components/multiedit/temporary/storageshared/MoveInfoDialog.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'VendorCodeCellElementLite',
  props: {
    element: {},
    entityId: {}
  },
  setup(__props: any) {

const props = __props;

const t = (k: string) => i18n.global.t(k);
const $q = useQuasar();
const storage = storageStore();
const storagePos = storagePositionsStore();

const renderedHtml = computed(() => formatSimpleHtml(props.element, t));
const isItem = computed(() => props.element.Category === ColumnCategory.ItemVendorCode);
const storageWA = computed(() => !!storage.storageAccess?.CanWrite);

// Диалог инфо открываем через $q.dialog (монтаж в корне приложения), а не inline
// q-dialog в шаблоне ячейки: ячейка живёт внутри виртуализированной таблицы и при
// пере-рендере строки локальный флаг открытия сбрасывался бы, закрывая окно.
// createType для движения НЕ передаём: тип подгрузит preloadExistingMovement по id.
function openInfo() {
  if (!props.entityId) return;
  if (isItem.value) {
    $q.dialog({
      component: ItemInfoDialog,
      componentProps: { existingPositionId: props.entityId },
    });
  } else {
    $q.dialog({
      component: MoveInfoDialog,
      componentProps: { existingMovementId: props.entityId },
    });
  }
}

const cloneConfirmOpen = ref(false);
const cloneMenuPos = ref<{ top: string; left: string }>({ top: "0px", left: "0px" });
const cloneBtnRef = ref<HTMLElement | null>(null);

function openCloneConfirm(ev: MouseEvent) {
  if (!storageWA.value) return;
  const rect = cloneBtnRef.value?.getBoundingClientRect();
  if (rect) {
    cloneMenuPos.value = { top: `${rect.bottom + 2}px`, left: `${rect.left}px` };
  } else {
    cloneMenuPos.value = { top: `${ev.clientY}px`, left: `${ev.clientX}px` };
  }
  cloneConfirmOpen.value = true;
}

function confirmClone() {
  if (props.entityId) storagePos.cloneStorageItem(props.entityId);
  cloneConfirmOpen.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("span", {
        class: "qtl-vendor__text",
        innerHTML: renderedHtml.value
      }, null, 8, _hoisted_2),
      (_ctx.entityId)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "qtl-vendor__btn",
            title: t('info'),
            "aria-label": t('info'),
            onClick: _withModifiers(openInfo, ["stop"])
          }, [
            _createVNode(AppIcon, {
              name: "info-circle-outline",
              width: "18px",
              color: "#979797",
              "hover-color": "#499259",
              cursor: "pointer"
            })
          ], 8, _hoisted_3))
        : _createCommentVNode("", true),
      (isItem.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            ref_key: "cloneBtnRef",
            ref: cloneBtnRef,
            type: "button",
            class: "qtl-vendor__btn qtl-vendor__btn--clone",
            disabled: !storageWA.value,
            title: t('clone'),
            "aria-label": t('clone'),
            onClick: _withModifiers(openCloneConfirm, ["stop"])
          }, [
            _createVNode(_component_q_icon, {
              name: "content_copy",
              size: "18px"
            })
          ], 8, _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    (isItem.value)
      ? (_openBlock(), _createBlock(MostaContextMenu, {
          key: 0,
          visible: cloneConfirmOpen.value,
          position: cloneMenuPos.value,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (cloneConfirmOpen.value = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(t('sure_clone_position')), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  type: "button",
                  class: "qtl-vendor-confirm__btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (cloneConfirmOpen.value = false))
                }, _toDisplayString(t('cancel')), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "qtl-vendor-confirm__btn qtl-vendor-confirm__btn--accent",
                  onClick: confirmClone
                }, _toDisplayString(t('clone')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible", "position"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})